import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { AppModuleGlobalShared } from '../../../app.module.global';
import { CoreModule } from '../../core/core.module';
import { SolicitudCamWrapperComponent } from './datosbasicos/solicitud-cam-wrapper/solicitud-cam-wrapper.component';
import { SolicitudCamEditComponent } from './datosbasicos/solicitud-cam-edit/solicitud-cam-edit.component';
import { SolicitudCamService } from './datosbasicos/solicitud-cam.service';
import { SolicitudesCamRoutingModule } from './solicitudes-cam-routing.module';
import { SolicitudRecintoCamWrapperComponent } from './recintos/solicitud-recinto-cam-wrapper/solicitud-recinto-cam-wrapper.component';
import { SolicitudRecintoCamHeaderComponent } from './recintos/solicitud-recinto-cam-header/solicitud-recinto-cam-header.component';
import { SolicitudCultivoCamService } from './recintos/solicitud-cultivo-cam.service';
import { RecintoModule } from '../recintos/recinto.module';
import { SolicitudAlmacenCamService } from './recintos/solicitud-almacen-cam.service';
import { RegistrosModule } from '../../_mantenimiento/registros/registros.module';
import { SolicitudRecintoCamWrapperAlmacenesComponent } from './recintos/solicitud-recinto-cam-wrapper-almacenes/solicitud-recinto-cam-wrapper-almacenes.component';
import { EspeciesModule } from '../../_mantenimiento/especies/especies.module';
import { SolicitudDocumentacionWrapperComponent } from './documentacion/solicitud-documentacion-wrapper/solicitud-documentacion-wrapper.component';
import { SolicitudDocumentacionHeaderComponent } from './documentacion/solicitud-documentacion-header/solicitud-documentacion-header.component';
import { SolicitudDocumentacionListComponent } from './documentacion/solicitud-documentacion-list/solicitud-documentacion-list.component';
import { DocumentosSolicitudCamService } from './documentacion/solicitud-documentacion.service';
import { SolicitudDocumentacionEditionComponent } from './documentacion/solicitud-documentacion-edition/solicitud-documentacion-edition.component';
import { SolicitudCamEnvioWrapperComponent } from './envio/solicitud-cam-envio-wrapper/solicitud-cam-envio-wrapper.component';
import { SolicitudCamEnvioFormComponent } from './envio/solicitud-cam-envio-form/solicitud-cam-envio-form.component';
import { ValidacionAceptacionWrapperComponent } from './validacion-aceptacion/validacion-aceptacion-wrapper/validacion-aceptacion-wrapper.component';
import { ValidacionAceptacionFormComponent } from './validacion-aceptacion/validacion-aceptacion-form/validacion-aceptacion-form.component';
import { SolicitudCamEnvioErroresComponent } from './envio/solicitud-cam-envio-errores/solicitud-cam-envio-errores.component';
import { GeneralModule } from '../../_mantenimiento/general/general.module';
import { SolicitudRecintoCamWrapperEmpresasDeshidratadorasComponent } from './recintos/solicitud-recinto-cam-wrapper-empresas-deshidratadoras/solicitud-recinto-cam-wrapper-empresas-deshidratadoras.component';
import { SolicitudEmpresaDeshidratadoraCamService } from './recintos/solicitud-empresa-deshidratadora-cam.service';
import { SolicitudRecintoCamWrapperCultivosComponent } from './recintos/solicitud-recinto-cam-wrapper-cultivos/solicitud-recinto-cam-wrapper-cultivos.component';

@NgModule({
    declarations: [
        SolicitudRecintoCamWrapperAlmacenesComponent,
        SolicitudCamWrapperComponent,
        SolicitudCamEditComponent,
        SolicitudRecintoCamWrapperComponent,
        SolicitudRecintoCamHeaderComponent,
        SolicitudDocumentacionWrapperComponent,
        SolicitudDocumentacionHeaderComponent,
        SolicitudDocumentacionListComponent,
        SolicitudDocumentacionEditionComponent,
        SolicitudCamEnvioWrapperComponent,
        SolicitudCamEnvioFormComponent,
        ValidacionAceptacionWrapperComponent,
        ValidacionAceptacionFormComponent,
        SolicitudCamEnvioErroresComponent,
        SolicitudRecintoCamWrapperEmpresasDeshidratadorasComponent,
        SolicitudRecintoCamWrapperCultivosComponent,
    ],
    exports: [],
    imports: [
        GeneralModule, // Componentes empresas-deshidratadoras
        RegistrosModule, // Componentes codigo-confeccion
        RecintoModule, // Componentes recintos
        EspeciesModule, // Variedad-list component
        CoreModule, // Componente Dialog
        AppModuleGlobalShared, // Pipes y componentes de PrimeNg, CoreUI o demás de formularios
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        SolicitudesCamRoutingModule,
        RouterModule.forRoot([], { bindToComponentInputs: true }),
    ],
    providers: [
        SolicitudEmpresaDeshidratadoraCamService,
        SolicitudAlmacenCamService,
        SolicitudCamService,
        SolicitudCultivoCamService,
        DocumentosSolicitudCamService,
    ],
})
export class SolicitudesCamModule {}
